import {useCallback, useEffect, useRef} from 'react';

export const useDebounce = <Args extends unknown[]>(
    fn: (...args: Args) => void,
    delayMs: number,
) => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return useCallback((...args: Args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            fn(...args);
        }, delayMs);
    }, [fn, delayMs]);
};
